import Vue from 'vue'

function sortAudioQueue(queue) {
    return queue
        .sort((left, right) => {
            if (right.priority !== left.priority) {
                return right.priority - left.priority
            }

            return new Date(left.createdAt).getTime() - new Date(right.createdAt).getTime()
        })
        .slice(0, 20)
}

export default {
    SET_LOCALE (state, value) {
        state.locale = value
    },
    SET_LOADING (state, value) {
        state.loading = value
    },
    SET_CURRENCY (state, value) {
        state.currency = value
    },
    TOGGLE_LOTS (state, value) {
        state.showLots = !state.showLots
    },
    SET_USER (state, value) {
        state.user = value
    },
    SET_AUCTION (state, value) {
        state.auction = {...state.auction, ...value}
    },
    SET_STREAM (state, value) {
        if(state.auction) {
            Vue.set(state.auction, 'cs', value)
        }
    },
    SET_LOT (state, value) {
        let index = state.lots.findIndex(lot => {
            return lot.id == value.id
        })

        if(value.w) {
            state.winner = value.w
        } else {
            state.winner = null
        }

        if(value.b) {
            state.bids = state.bids.concat(value.b.filter(bid => bid.a >= value.k))
        } else {
            state.bids.splice(0)
        }

        if(index >= 0) {
            Vue.set(state.lots, index, {...state.lots[index], ...value})
        } else {
            Vue.set(state.lots, 0, {...state.lots[0], ...value})
        }
    },
    SET_CURRENT_LOT (state, value) {
        state.lot = value.id
    },
    SET_LOTS (state, value) {
        state.lots = value
    },
    SET_SELECTED_LOT (state, value) {
        state.selectedLot = value
    },
    SET_BIDDERS (state, value) {
        state.bidders = value
    },
    ADD_BID (state, value) {
        if(! state.lot) return
        const lot = state.lots.find(item => {
            return item.id == state.lot
        })
        if(! lot) return
        if(value.a < lot.k) return
        state.bids.push(value)
    },
    ADD_BIDS (state, value) {
        state.bids = state.bids.concat(value)
    },
    RESET_BIDS (state, value) {
        state.bids.splice(0)
    },
    SET_WIN (state, value) {
        let index = state.lots.findIndex(lot => {
            return lot.id == value.lid
        })
        if(index >= 0) {
            state.lots[index].p = value.p
            state.lots[index].k = value.k
        }
        state.winner = value
    },
    RESET_WINNER (state, value) {
        state.winner = null
    },
    SET_WARN (state, value) {
        if(! value) return
        let index = state.lots.findIndex(lot => {
            return lot.id == value.id
        })
        if(index >= 0) {
            state.lots[index].warn = 1
        }
    },
    ADD_MESSAGE (state, value) {
        state.messages.push(value)
    },
    RESET_MESSAGES (state) {
        state.messages.length = 0
    },
    SET_TIMER (state, timer) {
        state.timer = timer
    },
    DECREASE_TIMER (state) {
        if(state.timer <= 0) return
        
        state.timer --;
    },
    SET_RECALL_TIMER (state, timer) {
        state.recallTimer = timer
    },
    DECREASE_RECALL_TIMER (state) {
        if(state.recallTimer <= 0) return

        state.recallTimer--;
    },
    INCREASE_TIMER (state, seconds) {
        if(state.timer <= 0) return
        
        state.timer += seconds;
    },
    SET_AUDIO_ENABLED (state, value) {
        state.audioEnabled = value
    },
    SET_AUDIO_BLOCKED (state, value) {
        state.audioBlocked = value
    },
    ENQUEUE_AUDIO_ANNOUNCEMENT (state, value) {
        state.audioQueue.push(value)
        state.audioQueue = sortAudioQueue(state.audioQueue)
    },
    PREPEND_AUDIO_ANNOUNCEMENT (state, value) {
        state.audioQueue = [value].concat(state.audioQueue.filter(item => item.id !== value.id)).slice(0, 20)
    },
    PROMOTE_AUDIO_ANNOUNCEMENT (state, value) {
        state.audioQueue = sortAudioQueue(
            state.audioQueue.map(item => {
                if (item.dedupeKey !== value.dedupeKey) {
                    return item
                }

                return {
                    ...item,
                    ...value,
                }
            })
        )
    },
    REMOVE_AUDIO_ANNOUNCEMENTS_BY_GROUP (state, queueGroup) {
        state.audioQueue = state.audioQueue.filter(item => item.queueGroup !== queueGroup)
    },
    REMOVE_AUDIO_ANNOUNCEMENT (state, announcementId) {
        state.audioQueue = state.audioQueue.filter(item => item.id !== announcementId)
    },
    CLEAR_AUDIO_QUEUE (state) {
        state.audioQueue = []
    },
    SET_ACTIVE_ANNOUNCEMENT (state, value) {
        state.activeAnnouncement = value
    },
    MARK_AUDIO_ANNOUNCEMENT_SEEN (state, value) {
        Vue.set(state.seenAnnouncementKeys, value.key, {
            at: value.at,
            status: value.status || null,
            hasAudioUrl: Boolean(value.hasAudioUrl),
        })
    },
    PRUNE_AUDIO_SEEN_KEYS (state, threshold) {
        Object.keys(state.seenAnnouncementKeys).forEach(key => {
            const seen = state.seenAnnouncementKeys[key]
            const seenAt = seen && typeof seen === 'object' ? seen.at : seen

            if (seenAt < threshold) {
                Vue.delete(state.seenAnnouncementKeys, key)
            }
        })
    }
}
